/*
 * File: short-currency.ts
 * Project: a-a
 * File Created: Friday, 17th January 2025 2:16:21 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 17th January 2025 2:20:01 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
export default function formatCurrency(value: number) {
  // Handle negative values, if necessary
  const isNegative = value < 0;
  value = Math.abs(value);

  // Suffixes for large numbers
  const suffixes = ['', 'K', 'M', 'B', 'T'];

  // Find the appropriate suffix based on the number size
  let suffixIndex = 0;
  while (value >= 1000 && suffixIndex < suffixes.length - 1) {
    value /= 1000;
    suffixIndex++;
  }

  // Format the number with 1 decimal point precision
  let formattedValue = value.toFixed(1);
  // Remove decimal part if it's 0
  if (parseFloat(formattedValue) % 1 === 0) {
    formattedValue = formattedValue.split('.')[0];
  }

  // Add the negative sign back if the number was negative
  if (isNegative) {
    formattedValue = `-${formattedValue}`;
  }

  // Add the suffix
  return formattedValue + suffixes[suffixIndex];
}
